import { render } from "./PopupSystem.vue?vue&type=template&id=711bc3c6&ts=true"
import script from "./PopupSystem.vue?vue&type=script&lang=ts"
export * from "./PopupSystem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__